module.exports = __webpack_public_path__ + "img/communicada-color.f2548b3b.png";